"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.TMSModelT = exports.UserT = exports.TaskModelT = exports.TaskT = exports.TagPrivateT = exports.TaskNoteT = exports.TagT = exports.StateT = exports.NoteTagT = exports.NotificationT = exports.NotificationCountT = exports.EventT = exports.EventTypeT = exports.DynoListT = exports.AuditT = exports.AuditNoteT = exports.AnnexT = exports.decodeTaskID = exports.encodeTaskID = void 0;
const tBox = __importStar(require("@sinclair/typebox"));
const lodash_1 = require("lodash");
const meta_types_1 = require("./meta-types");
const TLLM = __importStar(require("./types-llm-2"));
const HEX_GRANDFATHERED = 100_000;
const TEN_K = 10_000;
const encodeTaskID = (n) => {
    if (n < HEX_GRANDFATHERED) {
        return n.toString();
    }
    const hexPrefixPart = Math.floor(n / TEN_K);
    const decimalSuffix = n % TEN_K;
    const prefix = hexPrefixPart.toString(36);
    const suffix = (0, lodash_1.padStart)(String(decimalSuffix), 4, '0');
    return `${prefix}${suffix}`;
};
exports.encodeTaskID = encodeTaskID;
const decodeTaskID = (s) => {
    const asNum = Number(s);
    if (!isNaN(asNum) && String(asNum) === s) {
        return asNum;
    }
    const prefix = parseInt(s.slice(0, -4), 36);
    const suffix = Number(s.slice(-4));
    return prefix * TEN_K + suffix;
};
exports.decodeTaskID = decodeTaskID;
exports.AnnexT = tBox.Object({
    ID: tBox.String(),
    Title: tBox.String(),
    Description: tBox.String(),
    YearRevision: tBox.Number(),
    Reference: tBox.String(),
    Audits: tBox.Array(tBox.Number()),
});
exports.AuditNoteT = tBox.Object({
    ID: tBox.Number(),
    Audit: tBox.Number(),
    AuditResult: tBox.Number(),
    CorrectiveTask: (0, meta_types_1.MaybeT)(tBox.Number()),
    Note: tBox.String(),
    Timestamp: tBox.String(),
    User: tBox.Number(),
});
exports.AuditT = tBox.Object({
    ID: tBox.Number(),
    Title: tBox.String(),
    Description: tBox.String(),
    Frequency: tBox.Number(),
    LastAudit: tBox.String(),
    LastAuditResult: tBox.Number(),
    StartDate: tBox.String(),
    EndDate: (0, meta_types_1.MaybeT)(tBox.String()),
    NextDue: tBox.String(),
    NextStart: tBox.String(),
    Responsible: tBox.Number(),
    Window: tBox.Number(),
});
exports.DynoListT = tBox.Object({
    ID: tBox.Number(),
    Name: tBox.String(),
    Owner: tBox.Number(),
    Users: tBox.Array(tBox.Object({
        DynoList: tBox.Number(),
        User: tBox.Number(),
        Editable: tBox.Number(),
    })),
    Hidden: tBox.Number(),
    Description: tBox.String(),
    Model: tBox.String(),
});
exports.EventTypeT = tBox.Object({
    ID: tBox.Number(),
    Name: tBox.String(),
    Dismissable: tBox.Number(),
    MutatesPrior: tBox.Number(),
    PastTenseDesc: tBox.String(),
    RequiresParam: tBox.Number(),
});
exports.EventT = tBox.Object({
    ID: tBox.Number(),
    Timestamp: tBox.String(),
    Type: tBox.Number(),
    Task: tBox.Number(),
    Note: tBox.Number(),
    Target: tBox.String(),
    User: tBox.Number(),
});
exports.NotificationCountT = tBox.Object({
    Incomplete: tBox.Number(),
    Responsible: tBox.Number(),
    Total: tBox.Number(),
    User: tBox.Number(),
});
exports.NotificationT = tBox.Object({
    Task: tBox.Number(),
    IsRead: tBox.Number(),
    Latest: tBox.String(),
});
exports.NoteTagT = tBox.Object({
    ID: tBox.Number(),
    Name: tBox.String(),
    Image: tBox.String(),
    Description: tBox.String(),
});
exports.StateT = tBox.Object({
    ID: tBox.Number(),
    DescShort: tBox.String(),
    Description: tBox.String(),
    ConsiderationRefresh: tBox.Number(),
});
exports.TagT = tBox.Object({
    ID: tBox.Number(),
    FullName: tBox.String(),
    FullNameParts: tBox.Array(tBox.String()),
    FullNameShort: tBox.String(),
    Name: tBox.String(),
    NameSearchable: (0, meta_types_1.MaybeT)(tBox.String()),
    NameShort: (0, meta_types_1.MaybeT)(tBox.String()),
    IsContainer: tBox.Number(),
    IsDev: tBox.Number(),
    IsDoNotSupport: tBox.Boolean(),
    Outstanding: tBox.Array(tBox.Number()),
    ShowSidebar: tBox.Boolean(),
    SuperTag: tBox.Number(),
    Type: tBox.Number(),
    TypeNew: tBox.Number(),
});
exports.TaskNoteT = tBox.Object({
    ID: (0, meta_types_1.MaybeT)(tBox.Number()),
    Task: tBox.Number(),
    Auto: tBox.Number(),
    Author: tBox.Number(),
    IsMD: tBox.Number(),
    AISummary: tBox.Boolean(),
    AttachmentFile: (0, meta_types_1.MaybeT)(tBox.String()),
    AttachmentName: (0, meta_types_1.MaybeT)(tBox.String()),
    Note: tBox.Union([
        tBox.String(),
        tBox.Array(tBox.Tuple([tBox.Number(), tBox.Array(tBox.String())])),
    ]),
    Tags: tBox.Array(tBox.Number()),
    Summary: (0, meta_types_1.MaybeT)(tBox.String()),
    TS: tBox.String(),
});
exports.TagPrivateT = tBox.Object({
    ID: tBox.Number(),
    Name: tBox.String(),
    Description: tBox.String(),
    Owner: tBox.Number(),
    Permissions: tBox.Array(tBox.Number()),
});
exports.TaskT = tBox.Object({
    ID: tBox.Number(),
    Title: tBox.String(),
    Status: tBox.Number(),
    Importance: tBox.Number(),
    UrgencyShadow: (0, meta_types_1.MaybeT)(tBox.Number()),
    Assigned: (0, meta_types_1.ModelTypeT)(tBox.Number()),
    Prereqs: tBox.Array(tBox.Number()),
    Tags: tBox.Array(tBox.Number()),
    Due: (0, meta_types_1.MaybeT)(tBox.String()),
    DueFormat: tBox.String(),
    Created: tBox.String(),
    Updated: tBox.String(),
    Considered: (0, meta_types_1.MaybeT)(tBox.String()),
    Count: tBox.Number(),
    ETC: (0, meta_types_1.MaybeT)(tBox.Number()),
    Flag: tBox.Boolean(),
    PTags: (0, meta_types_1.ModelTypeT)(tBox.Object({
        Priority: tBox.Number(),
        Tag: tBox.Number(),
    })),
    Summary: (0, meta_types_1.MaybeT)(tBox.String()),
    _index: tBox.Number(),
});
exports.TaskModelT = tBox.Composite([
    exports.TaskT,
    tBox.Object({
        Notes: tBox.Array(exports.TaskNoteT),
    }),
]);
exports.UserT = tBox.Object({
    ID: tBox.Number(),
    FGiven: tBox.String(),
    Surname: tBox.String(),
    FullName: tBox.String(),
    ShortName: tBox.String(),
    SortingNameKey: tBox.String(),
    SortingNameKeyForced: tBox.String(),
    Email: tBox.String(),
    ShowSidebar: tBox.Boolean(),
    IsTMS4: tBox.Number(),
    HasNewFeatures: meta_types_1.tBoolT,
    FullAccess: tBox.Number(),
    Outstanding: tBox.Array(tBox.Number()),
    TriOnlineID: tBox.Number(),
    TagEditing: meta_types_1.tBoolT,
});
exports.TMSModelT = tBox.Object({
    User: tBox.Number(),
    allowedTasks: (0, meta_types_1.MaybeT)(tBox.Array(tBox.Number())),
    agentThreads: (0, meta_types_1.ModelStrT)(TLLM.AgentThreadT),
    annexes: (0, meta_types_1.ModelStrT)(exports.AnnexT),
    auditNotes: (0, meta_types_1.ModelTypeT)(tBox.Array(exports.AuditNoteT)),
    audits: (0, meta_types_1.ModelTypeT)(exports.AuditT),
    dynoLists: (0, meta_types_1.ModelTypeT)(exports.DynoListT),
    eventTypes: (0, meta_types_1.ModelTypeT)(exports.EventTypeT),
    events: (0, meta_types_1.ModelTypeT)(exports.EventT),
    kbTitles: (0, meta_types_1.ModelTypeT)(tBox.String()),
    lastUpdated: tBox.Number(),
    noteTags: (0, meta_types_1.ModelTypeT)(exports.NoteTagT),
    notes: (0, meta_types_1.ModelTypeT)(tBox.Array(exports.TaskNoteT)),
    notificationCounts: (0, meta_types_1.ModelTypeT)(exports.NotificationCountT),
    notifications: tBox.Array(exports.NotificationT),
    notificationsMuted: (0, meta_types_1.ModelTypeT)(tBox.String()),
    starred: tBox.Array(tBox.Number()),
    states: (0, meta_types_1.ModelTypeT)(exports.StateT),
    tags: (0, meta_types_1.ModelTypeT)(exports.TagT),
    tagsPrivate: (0, meta_types_1.ModelTypeT)(exports.TagPrivateT),
    tagsStarred: tBox.Array(tBox.Number()),
    taskForwarding: (0, meta_types_1.ModelTypeT)(tBox.Number()),
    taskKeys: tBox.Array(tBox.Number()),
    tasks: (0, meta_types_1.ModelTypeT)(exports.TaskT),
    users: (0, meta_types_1.ModelTypeT)(exports.UserT),
});
//# sourceMappingURL=types-tms.js.map